const STATUS_CONFIG = {
  not_required: {
    label: 'Not required',
    badgeClass: 'bg-secondary',
    icon: 'fa-minus-circle',
    theme: 'neutral',
  },
  verified_previous: {
    label: 'Verified (previous order)',
    badgeClass: 'bg-success',
    icon: 'fa-check-circle',
    theme: 'success',
  },
  product_unverified: {
    label: 'ID check product — customer not verified',
    badgeClass: 'bg-warning text-dark',
    icon: 'fa-exclamation-circle',
    theme: 'warning',
  },
  awaiting_dob: {
    label: 'ID check required — awaiting customer DOB',
    badgeClass: 'bg-warning text-dark',
    icon: 'fa-clock',
    theme: 'warning',
  },
  pending_verification: {
    label: 'ID check required — verification pending',
    badgeClass: 'bg-warning text-dark',
    icon: 'fa-clock',
    theme: 'warning',
  },
  dob_submitted: {
    label: 'DOB received — Hub check pending or inconclusive',
    badgeClass: 'bg-info text-dark',
    icon: 'fa-id-card',
    theme: 'info',
  },
  verified: {
    label: 'Hub verified',
    badgeClass: 'bg-success',
    icon: 'fa-check-circle',
    theme: 'success',
  },
  verified_manual: {
    label: 'Manually verified (photo ID)',
    badgeClass: 'bg-success',
    icon: 'fa-check-circle',
    theme: 'success',
  },
  hub_failed: {
    label: 'Hub failed — photo ID required',
    badgeClass: 'bg-danger',
    icon: 'fa-exclamation-triangle',
    theme: 'danger',
  },
  hub_failed_request_sent: {
    label: 'Hub failed — ID request sent to customer',
    badgeClass: 'bg-danger',
    icon: 'fa-paper-plane',
    theme: 'danger',
  },
  id_request_sent: {
    label: 'Photo ID request sent to customer',
    badgeClass: 'bg-warning text-dark',
    icon: 'fa-paper-plane',
    theme: 'warning',
  },
};

export function isIdCheckProduct(idCheckSummary, sku) {
  if (!sku) return false;
  return (idCheckSummary?.idCheckProducts || []).some((product) => product.sku === sku);
}

export function getStatusDisplay(idCheckSummary) {
  const key = idCheckSummary?.status || 'not_required';
  return STATUS_CONFIG[key] || STATUS_CONFIG.not_required;
}

export function formatDob(value) {
  if (!value) return null;
  try {
    return new Date(value).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return String(value);
  }
}

export function formatDateTime(value) {
  if (!value) return null;
  try {
    return new Date(value).toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return String(value);
  }
}
